import type { Permission, PermissionName } from './permission.types';

export function hasUserPermission(
  chosenPermission: PermissionName,
  userPermissions: Permission[],
): boolean {
  const permission = userPermissions.find((p) => p.permission_name === chosenPermission);
  if (!permission) {
    return false;
  }
  return permission.active && permission.state === 'assigned';
}

export function permissionIsNotSet(
  chosenPermission: PermissionName,
  userPermissions: Permission[],
) {
  const permission = userPermissions.find((p) => p.permission_name === chosenPermission);
  if (!permission) {
    return false;
  }
  return permission.state === 'not-set';
}
